module.exports = __webpack_public_path__ + "img/img_Colleges16.4e11eafb.jpg";